import React, { Component } from "react";
import queryString from "query-string";

import { Card, CardBody, Col, Container, Row, Form } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MiniWidget from "../../../../components/MiniWidget/index";
import {
  getQualityBannerStats,
  getQualityWidgets,
  setNonCahortReportDate,
  getQualityFilters,
  setQualityFilters,
  setQualityEvents,
  setQualityTable,
  setQualityBannerStats,
  getReportEventsStats
} from "../../../../store/reporting/actions";
import { getEvents, setEvents } from "../../../../store/events/actions";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import CustomBreadcrumbs from "../../../../components/Common/CustomBreadcrumbs";
import {
  getCurrentDay,
  getSelectedMonthAgo,
  formatNumbersForTable,
  formattedObjectsForFilter,
} from "./../../../../helpers/utils";
import DynamicFormToFilter from "./../../../../components/forms/DynamicFormToFilter";
import { getApplications } from "../../../../store/apps/actions";
import CustomCurrencySelect from "../../../../components/CustomCurrencySelect/CustomCurrencySelect";
import DefaultMultipleSelect from "../../../../components/DefaultMultipleSelect/DefaultMultipleSelect";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';
import ProgressDataBudget from "./ProgressDataBudget";

class QualityBannerStats extends Component {
  constructor(props) {
    super(props);
    this.styleNumbers = {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    };
    this.bannerBreadCrumbs = [
      {
        link: `/quality-report/${this.props.match.params.app_id}`,
        title: "All Media Sources",
      },
      {
        link: `/quality-report/${this.props.match.params.app_id}/${this.props.match.params.media_source}`,
        title: this.props.match.params.media_source,
      },
      {
        link: `/quality-report/${this.props.match.params.app_id}/${this.props.match.params.media_source}/${this.props.match.params.campaign_id}`,
        title: this.props.match.params.campaign_id,
      },
      {
        active: true,
        title: this.props.match.params.adgroup_id,
      },
    ];
    this.bannerColumns = [
      {
        Header: "Ad ID",
        src: "ad_id",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: "ad_id",
        isSorted: true,
      },
      {
        Header: "Payment",
        src: "payment",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.payment),
        isSorted: true,
      },
      {
        Header: "Spend",
        src: "spend",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.spend),
        isSorted: true,
      },
      {
        Header: "Profit",
        src: "profit",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.profit),
        isSorted: true,
      },
      {
        Header: "Cashback",
        src: "cashback",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.cashback),
        isSorted: true,
      },
      {
        Header: "Clicks",
        src: "clicks",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.clicks),
        isSorted: true,
      },
      {
        Header: "Impressions",
        src: "shows",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.shows),
        isSorted: true,
      },

      {
        Header: "Installs",
        src: "installs",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.installs),
        isSorted: true,
      },
      {
        Header: "CTR",
        src: "CTR",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CTR) + "%",
        isSorted: true,
      },
      {
        Header: "CPC",
        src: "CPC",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CPC),
        isSorted: true,
      },
      {
        Header: "CPM",
        src: "CPM",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CPM),
        isSorted: true,
      },
      {
        Header: "CR",
        src: "CR",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CR),
        isSorted: true,
      },
      {
        Header: "CPI",
        src: "CPI_post_click_plus_post_view",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row =>
          formatNumbersForTable(row.CPI_post_click_plus_post_view),
        isSorted: true,
      },
    ];

    this.state = {
      reports: [
        {
          icon: "mdi mdi-eye-check-outline",
          title: "Impressions",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-cursor-default-click-outline",
          title: "Clicks",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-contactless-payment-circle-outline",
          title: "Payment",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-100",
          title: "Spend",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-plus",
          title: "Profit",
          value: 0,
        },
      ],
      clients: [],
      breadcrumbs: [],
      columns: [],
      currency: [
        { label: "USD", value: "USD" },
        { label: "EUR", value: "EUR" },
      ],
      selectedEvents: [],
      app_name: undefined,
    };
  }

  componentDidMount() {
    const app_id = this.props.match.params.app_id;
    const adgroup_id = this.props.match.params.adgroup_id;

    if (this.props.history.location.state == undefined) {
      this.props.getApplications(this.props.apps);
    }

    this.setState({ adgroup_id: adgroup_id });

    const data = this.props.banner_stats;

    if (adgroup_id) {
      let parsedSearch = queryString.parse(this.props.history.location.search);
      data.adgroup_id = adgroup_id;
      data.app_id = app_id;
      data.start_date = parsedSearch.start_date || getSelectedMonthAgo(2);
      data.end_date = parsedSearch.end_date || getCurrentDay();
      data.currency = parsedSearch.currency || this.state.currency[0].value;
      data.media_source = this.props.match.params.media_source;

      if (this.props.nonCahortDate === null) {
        let formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            start_date: data.start_date,
            end_date: data.end_date,
            currency: data.currency,
          })
        );

        this.props.setNonCahortReportDate(data);
        this.props.getQualityBannerStats(data);
        this.props.getQualityWidgets(data);
        this.props.getQualityFilters(data);
        this.setState({
          app_name: this.props.history.location.state?.app_name,
        });
        this.props.history.location.search = formQueryString;
        this.props.history.replace(this.props.history.location);
      } else {
        let parsedSearch = queryString.parse(
          this.props.history.location.search
        );
        let cahortDate = this.props.nonCahortDate;
        let updateCahort = {};

        updateCahort.app_id = app_id;
        updateCahort.adgroup_id = adgroup_id;
        updateCahort.start_date = cahortDate.start_date;
        updateCahort.end_date = cahortDate.end_date;
        updateCahort.currency = cahortDate.currency;
        updateCahort.media_source = this.props.match.params.media_source;

        let parsedObject = {
          start_date: updateCahort.start_date,
          end_date: updateCahort.end_date,
          currency: updateCahort.currency,
        };

        let formQueryString = "";

        if (cahortDate?.mediabuyers) {
          updateCahort.mediabuyers = cahortDate.mediabuyers;
          formQueryString = queryString.stringify(
            Object.assign(parsedSearch, {
              ...parsedObject,
              mediabuyers: updateCahort.mediabuyers.split(","),
            })
          );
        } else {
          formQueryString = queryString.stringify(
            Object.assign(parsedSearch, {
              ...parsedObject,
            })
          );
        }

        this.props.getQualityBannerStats(updateCahort);
        this.props.getQualityWidgets(updateCahort);
        this.props.getQualityFilters(updateCahort);
        this.setState({
          app_name: this.props.history.location.state?.app_name,
        });
        this.props.history.location.search = formQueryString;
        this.props.history.replace(this.props.history.location);
      }
      this.props.getEvents({
        tracker_app_id: app_id,
      });
      if (this.props.quality_table === null) {
        this.props.setQualityTable(this.bannerColumns);
      }
    }

    // this.setState({
    //   columns: this.bannerColumns,
    // });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.banner_stats !== this.props.banner_stats) {
      this.props.events.length <= 0 &&
        this.props.getEvents({
          tracker_app_id: this.props.match.params.app_id,
        });
    }
    if (prevState.app_name !== this.state.app_name) {
      let updBreadcrumbs = this.bannerBreadCrumbs;
      updBreadcrumbs[0]["state"] = { app_name: this.state.app_name };
      updBreadcrumbs[1]["state"] = { app_name: this.state.app_name };
      this.props.setQualityTable(this.bannerColumns);
      this.setState({
        breadcrumbs: updBreadcrumbs,
        app_name: this.state.app_name,
        columns: this.bannerColumns,
      });
    }

    if (prevProps.apps !== this.props.apps) {
      let currentSearch = queryString.parse(this.props.history.location.search);
      let appName = this.props.apps.results.find(
        app => app.app_id === this.props.match.params.app_id
      ).name;
      this.setState({ app_name: appName });
      this.props.history.location.search = queryString.stringify(currentSearch);
      this.props.history.replace(this.props.history.location);
    }

    if (prevProps.quality_widgets !== this.props.quality_widgets) {
      const widgets = this.props.quality_widgets[0];
      this.setState({
        reports: [
          {
            icon: "mdi mdi-eye-check-outline",
            title: "Impressions",
            value: widgets?.shows_sum || 0,
            badgeValue:
              widgets?.shows_change > 0
                ? `+ ${widgets?.shows_change}%`
                : widgets?.shows_change !== undefined
                  ? `- ${widgets?.shows_change}%`
                  : `Undefined`,
            color: widgets?.shows_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-cursor-default-click-outline",
            title: "Clicks",
            value: widgets?.clicks_sum || 0,
            badgeValue:
              widgets?.clicks_change > 0
                ? `+ ${widgets?.clicks_change}%`
                : widgets?.clicks_change !== undefined
                  ? `- ${widgets?.clicks_change}%`
                  : `Undefined`,
            color: widgets?.clicks_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-contactless-payment-circle-outline",
            title: "Payment",
            value: this.props.quality_widgets[0]?.payment_sum || 0,
          },
          {
            icon: "mdi mdi-cash-100",
            title: "Spend",
            value: this.props.quality_widgets[0]?.spend_sum || 0,
          },
          {
            icon: "mdi mdi-cash-plus",
            title: "Profit",
            value: this.props.quality_widgets[0]?.profit_sum || 0,
          },
        ],
      });
    }
    if (this.props.quality_events !== prevProps.quality_events) {
      let updated_events = this.bannerColumns.concat(this.props.quality_events);
      this.props.setQualityTable(updated_events);
    }
  }

  componentWillUnmount() {
    this.props.setQualityEvents([]);
    this.props.setQualityTable(null);
    this.props.setQualityFilters({});
    this.props.setEvents([]);
    this.setState({ selectedEvents: [] });
    this.props.setQualityBannerStats({
      ...this.props.banner_stats,
      results: [],
    });
  }

  onTableChange = data => {
    let bannerData = this.props.banner_stats;
    let cahortDate = this.props.nonCahortDate;

    this.props.banner_stats.ordering = data?.ordering;
    this.props.banner_stats.page = data.page;
    this.props.banner_stats.sizePerPage = data.sizePerPage;

    this.props.getQualityBannerStats(this.props.banner_stats, {
      start_date: bannerData.start_date,
      end_date: bannerData.end_date,
      grouping: 'banner',
      currency: cahortDate?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });
  };

  onFiltersChange = (type, filter, filter_type) => {
    const data = this.props.banner_stats;
    const prevSearch = queryString.parse(this.props.history.location.search);

    data.start_date = filter.start_date;
    data.end_date = filter.end_date;
    data.app_id = this.props.match.params.app_id;
    data.media_source = this.props.match.params.media_source;
    data.adgroup_id = this.props.match.params.adgroup_id;

    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, filter)
    );

    switch (filter_type) {
      case "banner_id":
        data.banner_id = filter.banner_id.join();
        break;
      case "mediabuyers":
        data.mediabuyers = filter.mediabuyers.join();
        break;
    }

    this.props.history.location.state !== undefined &&
      this.setState({ app_name: this.props.history.location.state.app_name });

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.setNonCahortReportDate(data);

    this.props.getQualityBannerStats(data, {
      start_date: data.start_date,
      end_date: data.end_date,
      grouping: 'banner',
      currency: data?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: data.app_id,
    });
    this.props.getQualityWidgets(data);
  };

  onCurrencyChange = data => {
    const updateData = this.props.banner_stats;
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        currency: data.value,
      })
    );
    updateData.currency = data.value;

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.setNonCahortReportDate(updateData);
    this.props.getQualityWidgets(updateData);
    this.props.getQualityBannerStats(updateData, {
      start_date: updateData.start_date,
      end_date: updateData.end_date,
      grouping: 'banner',
      currency: updateData?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });
  };

  eventListener = data => {
    let filteredData = [];
    let prevHistory = queryString.parse(this.props.history.location.search);

    let ad_ids = []
    let params = {};
    let bannerData = this.props.banner_stats;
    let cahortDate = this.props.nonCahortDate;

    if (bannerData.results.length > 0) {
      bannerData.results.map(i => {
        ad_ids.push(i?.ad_id)
      })

      params = {
        ad_id: ad_ids.join(','),
        start_date: bannerData?.start_date,
        end_date: bannerData?.end_date,
        grouping: 'banner',
        currency: cahortDate?.currency || "USD",
        event_name: [data.map(i => i.label)].join(','),
        tracker_app_id: this.props.match.params.app_id,
      }

      this.props.getReportEventsStats(params);
    }

    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        event_id: filteredData,
      })
    );

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);

    this.setState({
      selectedEvents: data,
    })
  };

  render() {
    const widgetData = this.props.quality_widgets;
    
    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title={`${this.state?.app_name || 'Quality non cohort report'} | Mobihunter`} />

          <Container fluid>
            {this.state.app_name !== undefined && (
              <>
                <Breadcrumbs
                  title="Quality non cohort report"
                  breadcrumbItem={this.state.app_name}
                  link="/quality-report"
                />

                <DynamicFormToFilter
                  onFiltersChange={this.onFiltersChange}
                  filtersFields={[
                    {
                      filterData: [],
                      plug: "Banner ID...",
                    },
                    // {
                    //   filterData: formattedObjectsForFilter(
                    //     this.props.quality_filters,
                    //     "media_buyers"
                    //   ),
                    //   plug: "Media buyers...",
                    //   filterType: "mediabuyers",
                    // },
                  ]}
                  selectedDate={
                    Object.keys(
                      queryString.parse(this.props.history.location.search)
                    ).length == 0
                      ? this.props.nonCahortDate
                      : queryString.parse(this.props.history.location.search)
                  }
                  filtered_by={["banner_id", "mediabuyers"]}
                  filtered_params={queryString.parse(
                    this.props.history.location.search
                  )}
                />
                
                <ProgressDataBudget widgetData={widgetData} nonCahortDate={this.props.nonCahortDate} />

                <Col xl={12}>
                  <Row>
                    <MiniWidget
                      data={this.state.reports}
                      loading={this.props.widget_loader}
                    />
                  </Row>
                </Col>

                <Row>
                  <Col className="col-12">
                    <Card>
                      <CardBody>
                        <Row className="justify-content-between align-middle">
                          <Col xs={6}>
                            <h4 className="mb-3">Quality non cohort report</h4>
                            <CustomBreadcrumbs
                              breadcrumbItem={this.state.breadcrumbs}
                            />
                          </Col>
                          <Col xs={6} className="align-content-end">
                            <Form className="row align-items-center float-end ms-1">
                              <div className="col-sm-auto">
                                <CustomCurrencySelect
                                  options={this.state.currency}
                                  onChange={this.onCurrencyChange}
                                  defaultValue={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                />
                              </div>
                            </Form>
                            <Form className="row align-items-center float-end">
                              <div className="col-sm-4">
                                <DefaultMultipleSelect
                                  options={this.props.events.map(
                                    ({ value, label, checked }) => ({
                                      key: value,
                                      text: label,
                                      checked,
                                    })
                                  )}
                                  filtered_params={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                  onChange={this.eventListener}
                                  filtered_by="event_id"
                                  plug="Select events.."
                                  search
                                />
                              </div>
                            </Form>
                          </Col>
                        </Row>
                        {this.props.quality_table !== null && (
                          <ReactTableForm
                            loading={this.props.loading}
                            columns={this.props.quality_table}
                            data={this.props.banner_stats}
                            onTableChange={this.onTableChange}
                            firstIsSticky
                          />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

QualityBannerStats.propTypes = {
  history: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      media_source: PropTypes.string,
      campaign_id: PropTypes.node,
      adgroup_id: PropTypes.node,
      app_id: PropTypes.node,
    }).isRequired,
  }).isRequired,
  apps: PropTypes.any,
  nonCahortDate: PropTypes.any,
  getQualityBannerStats: PropTypes.func.isRequired,
  setQualityBannerStats: PropTypes.func.isRequired,
  banner_stats: PropTypes.any.isRequired,
  quality_widgets: PropTypes.any,
  quality_events: PropTypes.any,
  quality_table: PropTypes.any,
  widget_loader: PropTypes.bool,
  quality_filters: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getQualityWidgets: PropTypes.func.isRequired,
  setNonCahortReportDate: PropTypes.func.isRequired,
  getApplications: PropTypes.func.isRequired,
  getQualityFilters: PropTypes.func.isRequired,
  setQualityFilters: PropTypes.func.isRequired,
  setQualityEvents: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  setQualityTable: PropTypes.func.isRequired,
  getReportEventsStats: PropTypes.func.isRequired,
  setEvents: PropTypes.func.isRequired,
  events: PropTypes.any,
};

const mapStateToProps = state => ({
  apps: state.Apps.data,
  events: state.Events.events,
  banner_stats: state.Reporting.banner_stats,
  quality_widgets: state.Reporting.quality_widgets,
  quality_filters: state.Reporting.quality_filters,
  loading: state.Reporting.loading,
  widget_loader: state.Reporting.widget_loader,
  nonCahortDate: state.Reporting.nonCahortDate,
  quality_events: state.Reporting.quality_events,
  quality_table: state.Reporting.quality_table,
});

export default connect(mapStateToProps, {
  getQualityBannerStats,
  setQualityBannerStats,
  getQualityWidgets,
  setNonCahortReportDate,
  getApplications,
  getQualityFilters,
  setQualityFilters,
  setQualityEvents,
  setQualityTable,
  getEvents,
  getReportEventsStats,
  setEvents
})(QualityBannerStats);
